import { useState, useEffect, useRef } from "react";
import { useCartData } from "@/zustand/cartStore";
import { useProductData } from "@/zustand/productStore";
import EmailMarketingLeadsProvider from "@/utils/emailMarketing/EmailMarketingLeadsProvider";

export const useEmailMarketingLead = () => {
  const [hasCreatedLead, setHasCreatedLead] = useState(false);
  const [isProviderReady, setIsProviderReady] = useState(false);
  const providerRef = useRef(null);
  const { selectedProduct } = useCartData();
  const { emailMarketingConfig } = useProductData();
  const isKlaviyoLeadsEnabled = emailMarketingConfig?.isKlaviyoLeadsEnabled;

  useEffect(() => {
    if (!isKlaviyoLeadsEnabled) return;

    const initProvider = async () => {
      try {
        const provider = new EmailMarketingLeadsProvider();
        await provider.initialize();
        providerRef.current = provider;
        setIsProviderReady(true);
      } catch (error) {
        console.error("Failed to initialize email marketing:", error);
      }
    };

    initProvider();
  }, [isKlaviyoLeadsEnabled]);

  useEffect(() => {
    if (hasCreatedLead || !isProviderReady) return;

    const handleBlur = () => {
      if (hasCreatedLead) return;

      const emailInput = document.querySelector('input[name="email"]');
      const firstNameInput = document.querySelector('input[name="first_name"]');

      const email = emailInput?.value || "";
      const firstName = firstNameInput?.value || "";

      if (!email || !firstName) return;

      const emailError = document
        .querySelector('input[name="email"]')
        ?.parentElement?.parentElement?.querySelector(".formError");

      if (emailError && emailError.textContent) return;

      const leadData = {
        email,
        first_name: firstName,
        product_name: selectedProduct?.generic_name,
        product_qty: selectedProduct?.amount,
      };

      if (!providerRef.current?.validate(leadData)) return;

      setHasCreatedLead(true);

      providerRef.current.createLead(leadData).catch((error) => {
        console.error("Failed to create lead", error);
        setHasCreatedLead(false);
      });
    };

    const emailInput = document.querySelector('input[name="email"]');
    emailInput?.addEventListener("blur", handleBlur);

    return () => {
      emailInput?.removeEventListener("blur", handleBlur);
    };
  }, [hasCreatedLead, isProviderReady]);

  return hasCreatedLead;
};
